import axiosAPI from '@/api/axios'

export default {
  async fetchPixels(params) {
    return await axiosAPI.get('/api/pixels', {
      params: params,
    })
  },

  async savePixels(payload) {
    return await axiosAPI.post('/api/pixels', payload)
  },

  async testPixel(payload) {
    return await axiosAPI.post('/api/pixels/test', payload)
  },

  async fetchHistory(params) {
    return await axiosAPI.get('/api/pixels/history', {
      params: params,
    })
  },
}
